interface Config {
    API_BASE_URL: string;
    APP_ORY_URL: string;
    GOOGLE_ANALYTICS_TRACKING_ID: string;
    S3_PUBLIC_ASSETS_URL: string;
    ORY_JWT_TOKENIZE_AS: string;
    skipEmailVerification?: boolean;
    ENVIRONMENT: 'local' | 'dev' | 'stage' | 'prod';
    skipLandingPage?: boolean;
}

const localConfig: Config = {
    API_BASE_URL: 'http://localhost:8080/api',
    APP_ORY_URL: 'http://localhost:4000',
    GOOGLE_ANALYTICS_TRACKING_ID: '',
    S3_PUBLIC_ASSETS_URL: 'https://planner-dev-public-assets.s3.amazonaws.com',
    ORY_JWT_TOKENIZE_AS: 'planner.jwk.template',
    skipEmailVerification: true,
    ENVIRONMENT: 'local',
    skipLandingPage: false
};

const devConfig: Config = {
    API_BASE_URL: '/api',
    APP_ORY_URL: 'https://auth.dev.mantacares.com',
    GOOGLE_ANALYTICS_TRACKING_ID: 'G-5R85X8RFK3',
    S3_PUBLIC_ASSETS_URL: 'https://planner-dev-public-assets.s3.amazonaws.com',
    ORY_JWT_TOKENIZE_AS: 'planner.jwk.template',
    skipEmailVerification: true,
    ENVIRONMENT: 'dev',
    skipLandingPage: true
};

const stageConfig: Config = {
    API_BASE_URL: '/api',
    APP_ORY_URL: 'https://auth.stage.mantacares.com',
    GOOGLE_ANALYTICS_TRACKING_ID: 'G-66CEKBC0SM',
    S3_PUBLIC_ASSETS_URL: 'https://planner-stage-public-assets.s3.amazonaws.com',
    ORY_JWT_TOKENIZE_AS: 'planner.jwk.template',
    skipEmailVerification: true,
    ENVIRONMENT: 'stage',
    skipLandingPage: true
};

const prodConfig: Config = {
    API_BASE_URL: '/api',
    APP_ORY_URL: 'https://auth.mantacares.com',
    GOOGLE_ANALYTICS_TRACKING_ID: 'G-E42G7KL67B',
    S3_PUBLIC_ASSETS_URL: 'https://planner-prod-public-assets.s3.amazonaws.com',
    ORY_JWT_TOKENIZE_AS: 'planner.jwk.template',
    skipEmailVerification: true,
    ENVIRONMENT: 'prod',
    skipLandingPage: true
};

export const getConfig = (): Config => {
    if (window.location.origin.includes('localhost')) {
        return localConfig;
    }
    if (window.location.origin.includes('dev')) {
        return devConfig;
    }
    if (window.location.origin.includes('stage')) {
        return stageConfig;
    }
    return prodConfig;
};

export const sessionTimerConfig = () => {
    const second = 1;
    const min = 60 * second;
    // Represents jwt expiry time.
    const jwtExpiresIn = 120 * min;
    // refreshSessionBeforeExpiryIn represents at what time session should be extended.
    // Session will be extended for every 5mins before expiry time if user is active.
    const refreshSessionBeforeExpiryIn = 5 * min;

    return {
        // Represents max in active time for an user.
        // Before 2minutes of session expiry, a popup will appear asking if you'd like to extend your session or log out.
        maxInactiveTime: jwtExpiresIn - 2 * min,
        jwtExpiresIn,
        refreshSessionBeforeExpiryIn,
        noActionAutoLogoutTimer: 1.5 * min
    };
};
